import {
  AtlasPosition,
  AtlasBounds,
  AtlasIcon,
  AtlasMarkerOptions,
  AtlasIconOptions,
  AtlasLabel,
  AtlasLabelOptions,
  AtlasPolygonOptions,
  AtlasPopupOptions,
  AtlasPopup,
} from '../interfaces/mu-atlas-types.interface';
import { AtlasFactory } from '../interfaces/mu-atlas-factory.interface';
import { AtlasMarker } from '../interfaces/mu-atlas-marker.interface';
import { AtlasPolygon } from '../interfaces/mu-atlas-polygon.interface';

class GMBounds extends google.maps.LatLngBounds {
  getCenter(): any {
    const center = super.getCenter();
    return { lat: center.lat(), lng: center.lng() };
  }
}
class GMMarker extends google.maps.Marker {
  removeAllListeners(): void {
    google.maps.event.clearInstanceListeners(this);
  }
}
class GMPolygon extends google.maps.Polygon {
  getPath(): any {
    return super
      .getPath()
      .getArray()
      .map(point => {
        return { lat: point.lat(), lng: point.lng() };
      });
  }
}

export class MuMapLegacyFactory implements AtlasFactory {
  createBoundsInstance(position?: AtlasPosition): AtlasBounds {
    return new GMBounds(position) as unknown as AtlasBounds;
  }
  createMarkerInstance(options: AtlasMarkerOptions): AtlasMarker {
    const gOptions: google.maps.MarkerOptions = { position: options.position };
    if (options.label) {
      gOptions.label = options.label;
    }
    if (options.icon) {
      gOptions.icon = options.icon as unknown as google.maps.ReadonlyIcon
    }
    if (options.draggable) {
      gOptions.draggable = options.draggable;
      gOptions.crossOnDrag = false;
    }
    return new GMMarker(gOptions) as unknown as AtlasMarker;
  }
  createIconInstance(options: AtlasIconOptions): AtlasIcon {
    let gIcon: any = {
      url: options.url,
    };
    if (options.size) {
      gIcon.scaledSize = new google.maps.Size(options.size.width, options.size.height);
    }
    if (options.labelOrigin) {
      gIcon.labelOrigin = new google.maps.Point(options.labelOrigin.x, options.labelOrigin.y);
    }
    return gIcon as AtlasIcon;
  }
  createLabelInstance(options: AtlasLabelOptions): AtlasLabel {
    return options as AtlasLabel;
  }
  createPopupInstance(options: AtlasPopupOptions): AtlasPopup {
    return options as AtlasPopupOptions;
  }
  createPolygonInstance(options: AtlasPolygonOptions): AtlasPolygon {
    return new GMPolygon(options) as unknown as AtlasPolygon;
  }
}
